import React, { useEffect, useState, useRef } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import FlagCircleRoundedIcon from '@mui/icons-material/FlagCircleRounded'; 
import { axiosInstance } from "../../utility/apiInstance";
import OceanTrackingHeader from "../../components/OceanTracking/OceanTrackingHeader";
import OceanEventLine from "../../components/OceanTracking/OceanEventLine";
import OceanTableView from "../../components/OceanTracking/OceanTableView";
import TabularViewofFlagList, { FlagType } from "../../components/TabularViewofFlagList";

const defaultTheme = createTheme();

function OceanTrackingPage() {
  const { encodedocean } = useParams();

  const [oceanTrackList, setOceanTrackList] = useState<any>(null);
  const [vesselDetail, setVesselDetail] = useState<any[]>([]);
  const [billOfLadingUpdates, setBillOfLadingUpdates] = useState<any>({});
  const [billOfLadingUpdatesForTable, setBillOfLadingUpdatesForTable] =
    useState<any[]>([]);
  const [containerDataUpdate, setContainerDataUpdate] = useState<any[]>([]);
  const [selectedContainer, setSelectedContainer] = useState<string>("All");
  const [isFlag, setIsFlag] = useState(false);
  const [selectedContainer1, setSelectedContainer1] =
    useState<string>("Bill of Lading");

  const [firstAndLast, setFirstAndLast] = useState({
    first: [],
    last: [],
  });
  const [flag, setFlag] = useState<FlagType[]>([]);

  // 🔒 Prevent double API call in React 18 StrictMode (DEV)
  const apiCalledRef = useRef(false);

  useEffect(() => {
    if (!encodedocean) return;

    if (apiCalledRef.current) return;
    apiCalledRef.current = true;

    const fetchOceanTrackingDetails = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/ocean/public/traking-details/${encodedocean}`
        );

        if (!response.data?.success) return;

        const data = response.data.data;

        setOceanTrackList(data.header || null);
        setVesselDetail(data.header?.vessel || []);
        setBillOfLadingUpdates(data.billOfLadingData || {});
        setBillOfLadingUpdatesForTable(
          data.billOfLadingDataForTable || []
        );
        setContainerDataUpdate(data.containerData || []);

        setFirstAndLast({
          first: data.first || [],
          last: data.last || [],
        });
        setFlag(data?.shipmentFlagsDetails || [])

        // Handle CT vs Non-CT
        if (data.header?.type === "CT") {
          setSelectedContainer1("Container");
        } else {
          setSelectedContainer1("Bill of Lading");
        }

        // Default container selection
        if (data.containerData?.length > 0) {
          setSelectedContainer(Object.keys(data.containerData[0])[0]);
        } else {
          setSelectedContainer("All");
        }
      } catch (error: any) {
        toast.error(
          error?.response?.data?.error || "Failed to fetch tracking data"
        );
      }
    };

    fetchOceanTrackingDetails();
  }, [encodedocean]);

  const handleContainerChange = (value: string) => {
    setSelectedContainer(value);
  };

  const handleContainerChange1 = (value: string) => {
    setSelectedContainer1(value);
  };

  const filteredContainers =
    selectedContainer === "All"
      ? containerDataUpdate
      : containerDataUpdate.filter(
        (container: any) =>
          Object.keys(container)[0] === selectedContainer
      );

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="min-h-screen mt-8 p-5">
        <div className="grid grid-cols-12 gap-x-4">
          {/* LEFT SECTION */}
          <div className="lg:col-span-7 col-span-12">
            <OceanTrackingHeader
              oceanTrackList={oceanTrackList}
              vesselDetail={vesselDetail}
            />

            <div className="whiteBox whiteBoxCustom">
              <div className="flex flex-col w-full ">
                <div className="old_dashboard_title margin0 flex gap-3">
                  <h1 className="text-2xl font-bold text-gray-700 mt-[-15px] mb-[10px]">
                    List of Events
                  </h1>
                  {
                    flag && flag?.length >= 1 && (
                      <button className="mt-[-15px] mb-[10px]" onClick={() => setIsFlag(prev => !prev)}>
                        {/* <Badge badgeContent={flags?.length} color="error"> */}
                        <FlagCircleRoundedIcon />
                        {/* </Badge> */}
                      </button>
                    )
                  }
                </div>
                <div className="flex gap-3 ListEventsForm">
                  {/* BL / Container Toggle */}
                  <div className="form-group">
                    <select
                      value={selectedContainer1}
                      onChange={(e) =>
                        handleContainerChange1(e.target.value)
                      }
                    >
                      {oceanTrackList?.type !== "CT" && (
                        <option
                          className="text-black"
                          value="Bill of Lading"
                        >
                          Bill of Lading
                        </option>
                      )}
                      <option className="text-black" value="Container">
                        Container
                      </option>
                    </select>
                  </div>

                  {/* Container Selector */}
                  {selectedContainer1 === "Container" && (
                    <div className="form-group">
                      <div className="flex items-center">
                        {/* <img
                          src="/images/container2.svg"
                          className="w-[19px]"
                          alt="container"
                        /> */}
                        <select 
                          value={selectedContainer}
                          onChange={(e) =>
                            handleContainerChange(e.target.value)
                          }
                        >
                          <option className="text-black" value="All">
                            All
                          </option>
                          {containerDataUpdate.map(
                            (container: any, index: number) => {
                              const containerNumber =
                                Object.keys(container)[0];
                              return (
                                <option
                                  className="text-black"
                                  key={index}
                                  value={containerNumber}
                                >
                                  {containerNumber}
                                </option>
                              );
                            }
                          )}
                          {containerDataUpdate.length === 0 && (
                            <option className="text-black" disabled>
                              No containers available
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                  )}
                </div>


                {
                  isFlag ? (
                    <TabularViewofFlagList flags={flag} />
                  ) :
                    (<OceanTableView
                      billOfLadingUpdatesForTable={
                        billOfLadingUpdatesForTable
                      }
                      oceanTrackList={oceanTrackList}
                      selectedContainer1={selectedContainer1}
                      selectedContainer={selectedContainer}
                      filteredContainers={filteredContainers}
                      firstAndLast={firstAndLast}
                    />)
                }
              </div>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <OceanEventLine
            billOfLadingUpdates={billOfLadingUpdates}
            containerDataUpdate={containerDataUpdate}
            selectedContainer={selectedContainer}
            selectedContainer1={selectedContainer1}
            firstAndLast={firstAndLast}
          />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default OceanTrackingPage;
